import { REFRESH_TOKEN_COOKIES, TOKEN_COOKIES } from "@const/shared"
import { LoginResponse, RawTokenData, TokenData } from "@interfaces/auth"
import AuthServices from "@lib/api/services/auth.services"
import ky from "ky"
import { useRouter } from "next/router"
import nookies from "nookies"
import React, { createContext, useContext, useEffect, useState } from "react"

export interface UserContextProps {
  isLogin: number | boolean
  isVerified: number | boolean
  tokenData?: TokenData
  uid: string
  loading: boolean
  token: LoginResponse
}

const ComponentContext = createContext<Partial<UserContextProps>>({})

export const ComponentProvider = ({ children }: { children: React.ReactNode }) => {
  const [loading, setLoading] = useState(true)
  const [isLogin, setIsLogin] = useState(false)
  const [isVerified, setIsVerified] = useState(false)
  const [tokenData, setTokenData] = useState<TokenData | undefined>()
  const [token, setToken] = useState<LoginResponse | undefined>()
  const [uid, setUid] = useState("")

  const cookies = nookies.get({})
  const router = useRouter()
  const auth = new AuthServices()

  useEffect(() => {
    async function loadUserFromCookies(): Promise<void> {
      setLoading(true)
      const token = cookies[TOKEN_COOKIES]
      const refreshToken = cookies[REFRESH_TOKEN_COOKIES]

      if (token) {
        const res = await ky.post("/corporate-training/api/verify-token", { json: { token } })

        if (!res.ok) {
          await auth.logout()
          setIsVerified(false)
          window.location.reload()
        }

        const result = await res.json()

        const data = result.decoded as RawTokenData
        setIsVerified(true)
        setTokenData(data.data)
        setUid(data.uid)
        setToken({
          token,
          refreshToken,
        })
        setIsLogin(true)
      } else {
        setIsLogin(false)
      }

      setLoading(false)
    }

    if (cookies && loading) {
      loadUserFromCookies().then(() => null)
    }
  }, [cookies, router, loading])

  return (
    <ComponentContext.Provider value={{ isLogin, isVerified, tokenData, uid, loading, token }}>
      {children}
      {/*{!isLogin ? children : <MaintenancePage />}*/}
    </ComponentContext.Provider>
  )
}

export const useUserData = (): Partial<UserContextProps> => useContext(ComponentContext)
